import { render, staticRenderFns } from "./Icare.vue?vue&type=template&id=3e4ba0e0&"
import script from "./Icare.vue?vue&type=script&lang=js&"
export * from "./Icare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports